import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #32: A Map of Global Migrations, Part 1",
  "description": "",
  "published": "2017-02-07T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-32-map-global-migrations/swizec/7415"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://liveedu.tv/swizec"
        }}>{`here`}</a>{`. New content almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`You know, it's really hard to compete with the Super Bowl. This Sunday must have been the lowest live coding turnout I've ever seen.`}</p>
    <p>{`A cumulative of 80 people came to see me live, and that makes me happy, and I still don't know how `}<a parentName="p" {...{
        "href": "https://www.liveedu.tv/swizec/"
      }}>{`liveedu.tv`}</a>{` calculates that. It doesn't matter. It's a number, it's not zero, and that's great.`}</p>
    <p>{`Thanks to `}<a parentName="p" {...{
        "href": "https://www.liveedu.tv/mrmaru/"
      }}>{`mrmaru`}</a>{` for teaching me how to jump to the end of line (`}<inlineCode parentName="p">{`$`}</inlineCode>{`) and beginning of line (`}<inlineCode parentName="p">{`0`}</inlineCode>{`) in Vim. I sure feel dumb for holding the left and right arrow keys for the past 15 years like an idiot. Why didn't I look that up? ?`}</p>
    <p>{`Together, we talked about not understanding football and built this map:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/02/map-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`We're going to make it better next week. I know it doesn't look like much yet.`}</p>
    <p>{`Our (my?) goal is to build a map of global migrations using the `}<a parentName="p" {...{
        "href": "https://github.com/curran/data/blob/gh-pages/un/migration/README.md"
      }}>{`UN dataset`}</a>{` I mentioned `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-31-datasets-hard/swizec/7403"
      }}>{`last week`}</a>{`. Initially, I wanted to build one of those cool maps that change country sizes to represent a value. No idea how to do that. Yet.`}</p>
    <p>{`Instead we're drawing lines. Because I couldn't figure out how to make curves ?`}</p>
    <p>{`In my defense, I was tired and dying from a cold.`}</p>
    <p>{`Right now, you're seeing global migrations `}<em parentName="p">{`into`}</em>{` Djibouti. Lines connect `}<inlineCode parentName="p">{`source`}</inlineCode>{` migrations to their `}<inlineCode parentName="p">{`destination`}</inlineCode>{`. There's nothing about magnitude yet. That comes next week, and I'd love some suggestions on how to do that. Line thickness smells interesting but would probably look weird.`}</p>
    <p>{`Oh, and the lines are going to be curved. I think what I'm missing is a third point between the `}<inlineCode parentName="p">{`source`}</inlineCode>{` and `}<inlineCode parentName="p">{`destination`}</inlineCode>{`. Something to give D3's curve `}<inlineCode parentName="p">{`curveBasis`}</inlineCode>{` interpolator a reason to make a curve.`}</p>
    <p>{`Right now we're rendering the migrations layer as a React component, like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const Migrations = ({ topology, projection, data, nameIdMap }) => {
    const countries = topojson.feature(topology, topology.objects.countries),
          path = d3.geoPath(projection),
          centroids = _.fromPairs(countries.features
                                           .map(country => [country.id,
                                                            path.centroid(country)]));


    return (
        <g>
            <countrymigrations data={data[10]} nameidmap={nameIdMap} centroids={centroids}>
        </countrymigrations></g>
    );
};

const CountryMigrations = ({ data, nameIdMap, centroids }) => {
    const line = d3.line()
                   .curve(d3.curveBasis),
          destination = centroids[data.id];

    console.log(data.name);

    const sources =  Object.keys(data.sources)
                           .filter(name => centroids[nameIdMap[name]])
                           .map(name => centroids[nameIdMap[name]]);
    return (
        <g>
            {sources.map((source, i) => (
                <path d="{line([destination," source])}="" style="{{stroke:" 'black',="" strokewidth:="" '1px'}}="" key={\`\${data.id}-\${i}\`}>
             ))}
        </path></g>
    )
};
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`Migrations`}</inlineCode>{` component builds a dictionary of country centroids, which gives us a cached mapping from country `}<inlineCode parentName="p">{`id`}</inlineCode>{` to country centroid position. We use these as line anchors.`}</p>
    <p>{`Then we iterate through the list of countries and render `}<inlineCode parentName="p">{`CountryMigration`}</inlineCode>{` components. Well, in theory. There's just one `}<inlineCode parentName="p">{`CountryMigration`}</inlineCode>{` right now, so it's easier to debug.`}</p>
    <p>{`Each `}<inlineCode parentName="p">{`CountryMigration`}</inlineCode>{` component creates a `}<inlineCode parentName="p">{`d3.line`}</inlineCode>{` generator, compiles a list of `}<inlineCode parentName="p">{`sources`}</inlineCode>{`, then iterates through them and adds `}<inlineCode parentName="p">{`path`}</inlineCode>{` elements for each line. As you can see, this works, but it doesn't make curves because a curve between two points is a straight line.`}</p>
    <p>{`That sounds stupidly obvious when I say it out loud ?`}</p>
    <p>{`Join me next week as we curve the curves, add animation to represent migration volume, and maybe some interactivity. Mouseovers could filter countries? Perhaps.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      